import React, { Component, PropTypes } from 'react';
import Translator from 'bazinga-translator';
import Icon from '../../../../icons/icon.jsx';
import {icons} from '../../../../icons/constants.js';

export default class UploadView extends Component {
    static propTypes = {
        onFileChange: PropTypes.func
    };

    constructor(props){
        super(props);
    }

    handleFile(){
        let files = this.refs.fileInput.files;
        if (files.length > 0) {
            let formData = new FormData();
            formData.append('image', files[ 0 ]);
            this.props.onFileChange(formData);
        }
    }

    render() {
        return (
        <div className="MU_logotype--upload">
            <h6 className="MU_logotype--upload__title">{this.props.text} {Translator.trans('media_uploader.ver_empty', [], 'app')}</h6>
            <Icon icon={icons.uploadLogo}
                  color="#e2e2e2"
                  width={120}
                  height={104}/>
            <label className="MU_logotype--upload__label">
                <input type="file"
                       ref="fileInput"
                       className="MU_logotype--upload__input"
                       onChange={::this.handleFile}
                />
                <div className="btn -white MU_logotype--upload__button">{Translator.trans('media_uploader.upload', [], 'app')}</div>
            </label>
        </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/MediaUploaderSmall/UploadView.jsx